import { FlatActionList } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { useTranslation } from "../../../../../../utilities/i18n";
import { PaymentMethodFormValues } from "../../types";
import { Switch } from "react-native";

export interface AssignToTerminalInputFieldProps {}

export const AssignToTerminalInputField =
  ({}: AssignToTerminalInputFieldProps) => {
    const { t } = useTranslation("settings");
    const { control } = useFormContext<PaymentMethodFormValues>();
    return (
      <View>
        <FlatActionList
          items={[
            {
              key: "payment_method_assign_terminal",
              title: t("form.payment_method_assign_terminal.label"),
              subTitle: t("form.payment_method_assign_terminal.description"),
              onPress: () => {},
              componentRight: () => (
                <Controller
                  name="enabled"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <View>
                      <Switch
                        value={value}
                        onValueChange={() => {
                          onChange(!value);
                        }}
                      />
                    </View>
                  )}
                />
              ),
            },
          ]}
        />
      </View>
    );
  };
